const productdetail2 = [
    {
        id:1,
        title: "MEN'S WHITE T-SHIRT",
        image:require('./Images/21.webp'),
        price:75.25,
        count:1
    },
    {
        id:2,
        title: "MEN'S POLO T-SHIRT",
        image:require('./Images/22.webp'),
        price:68.88,
        count:1
    },
    {
        id:3,
        title: "MEN'S PLAIN T-SHIRT",
        image:require('./Images/23.webp'),
        price:99.99,
        count:1
    },
    {
        id:4,
        title: "MEN'S PRINT T-SHIRT",
        image:require('./Images/19.webp'),
        price:85.25,
        count:1
    },
    
]
export default productdetail2;